import { EVENT_SEARCH_SURPRISE_ME } from "../constants";

export default function propagateSearchModalSurprise(href: string) {
  // Check if we are in the client
  if (typeof window !== "object" || typeof CustomEvent !== "function") {
    console.warn(
      "[Search-ui] Calling search modal open on a server function, ignoring request...",
    );
    return;
  }

  const event = new CustomEvent(EVENT_SEARCH_SURPRISE_ME, {
    detail: {
      timestamp: Date.now(),
      href,
    },
  });

  window.dispatchEvent(event);
}
